export const getClientApiUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (!apiUrl) {
    throw new Error('VITE_API_URL is not defined. Add it to your .env file.');
  }
  return apiUrl;
};

export const getAseEmail = (): string => {
  return import.meta.env.VITE_EMAIL_ASE ?? '';
};

/** Self-hosted Protomaps vector basemap (UG-5349). Override per environment if needed. */
export const getBasemapTilesUrl = (): string => {
  return import.meta.env.VITE_BASEMAP_TILES_URL || 'https://tiles.utilitiesone.com/gpm-basemap/{z}/{x}/{y}.mvt';
};
